import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useMutation } from '@apollo/client'
import { GQL_QUERY_CURRENT_BRAND_INFO } from '@@partner:graphql/query/brand/currentBrandInfo.gql'
import type { BrandFile } from './setBrandFile.gql'

export interface RemoveBrandFileResult {
  removeBrandFile: {
    id: GQL_ID
    brandFiles: BrandFile[]
  }
}

export interface RemoveBrandFileVariables {
  file_id: number
}

export const GQL_MUTATION_REMOVE_BRAND_FILE = gql`
  mutation RemoveBrandFile($file_id: Int!) {
    removeBrandFile(file_id: $file_id) {
      id
      brandFiles {
        key
        file_id
        name
        fileSize
        addedAt
        file {
          url
        }
      }
    }
  }
`

export const useRemoveBrandFile = () => {
  return useMutation<RemoveBrandFileResult, RemoveBrandFileVariables>(
    GQL_MUTATION_REMOVE_BRAND_FILE,
    {
      refetchQueries: [ { query: GQL_QUERY_CURRENT_BRAND_INFO } ]
    }
  )
}
